import {useDispatch} from "react-redux";
import React, {useEffect, useState} from "react";
import {useShallowPickSelector} from "./redux";
import * as UserStore from "./redux/user";
import axios from "axios";
import {baseUrl} from "./api/network";
import * as Appstore from "./redux/app";
import celebrateAnimationData3 from "./assets/animations/celebrate3.json";
import Splash from "./pages/Splash";
import Modal from "./components/modal";
import RetryModal from "./components/RetryInApp";
import UnderMaintenance from "./pages/UnderMaintenance";
import {BrowserRouter as Router, Route, Routes, useNavigate} from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Signals from "./pages/Signals";
import DailyTasks from "./pages/DailyTasks";
import Affiliate from "./pages/affiliate/Affiliate";
import AffiliatePanel from "./pages/affiliate/AffiliatePanel";
import Checkout from "./pages/Checkout";
import Error from "./pages/Error";
import BottomNavigationMenu from "./components/bottomNavigationMenu/BottomNavigationMenu";
import Lottie from "react-lottie";
import * as AppStore from "./redux/app";

let timeout;

const Main = () => {
    const dispatch = useDispatch();
    const [splashState, setSplashState] = useState(1); // 0=false 1=true 2=under_maintenance
    const {showCelebrate} = useShallowPickSelector('app', ['showCelebrate']);
    const [showModal, setShowModal] = useState(false);
    const {tgUser} = useShallowPickSelector('user', ['tgUser']);
    const tg = window?.Telegram?.WebApp;
    const navigate = useNavigate()

    useEffect(() => {
        doFunctionsFn();
        goToHome();

        return () => {
            clearTimeout(timeout);
        }
    }, []);


    const doFunctionsFn = () => {
        if (tg?.initDataUnsafe?.user) {
            dispatch(UserStore.actions.setTgUser(tg?.initDataUnsafe?.user));
        }

        tg?.setHeaderColor('#1D1E24');

        // Optionally expand the web app to fill the screen
        tg?.expand();
    }

    const workWithStartParamFn = (startParam) => {
        if (startParam && startParam.toLowerCase().startsWith('page_')) {
            const destination = startParam.toLowerCase().replace('page_', '')
            setShowModal(false);
            setSplashState(0);
            dispatch(Appstore.getPointsDataFn())
            if (destination.startsWith('home')) {
                if (destination === 'home') {
                    navigate(`/`)
                } else if (destination === 'home-jetpoint') {
                    navigate(`/`)
                    dispatch(AppStore.actions.setHomeState(false))
                }
            } else if (destination.startsWith('alarms')) {
                if (destination === 'alarms-profit') {
                    navigate('/signals', { state: { tab: "tab1" } })
                } else if (destination === 'alarms-spotters') {
                    navigate('/signals', { state: { tab: "tab2" } })
                    dispatch(AppStore.actions.setHomeState(false))
                }
            } else {
                if (destination.includes('-')) {
                    navigate(`/${destination.replace('-', '/')}`)
                } else {
                    navigate(`/${destination}`)
                }
            }
        } else {
            doReferralFn()
        }
    }

    const doReferralFn = () => {
        const initData = tg?.initDataUnsafe;
        const headers = {
            'Content-Type': 'application/json',
        }
        const lastData = {
            ref_code: initData?.start_param ?? null,
            user_tg_id: tgUser?.id ?? tg?.initDataUnsafe?.user?.id,
        }
        axios.post(`${baseUrl}/points/store/tapp-affiliate`, JSON.stringify(lastData), {headers})
            .then(() => {
                // do nothing
                setShowModal(false);
                setSplashState(0);
                dispatch(Appstore.getPointsDataFn())
            })
            .catch(() => {
                // do nothing
            })
    }

    const goToHome = () => {
        setShowModal(false);
        const headers = {
            'Content-Type': 'application/json',
        }

        const user_tg_id = tgUser?.id ?? tg?.initDataUnsafe?.user?.id;
        const user_tg_username = tgUser?.username ?? tg?.initDataUnsafe?.user?.username ?? tgUser?.first_name ?? tg?.initDataUnsafe?.user?.first_name;

        timeout = setTimeout(() => {
            axios.get(`${baseUrl}/init?user_tg_id=${user_tg_id}&username_tg=${user_tg_username}`,{headers})
                .then((response) => {
                    if (response.data.status === '1') {
                        if (response.data?.data?.under_maintenance) {
                            setSplashState(2);
                        } else {
                            const initData = tg?.initDataUnsafe;
                            if (initData && initData?.start_param) {
                                workWithStartParamFn(initData?.start_param)
                            } else {
                                setShowModal(false);
                                setSplashState(0);
                            }
                        }
                    } else {
                        // show error modal
                        setShowModal(true);
                    }
                })
                .catch(() => {
                    // show error modal
                    setShowModal(true);
                })
        }, 3000)
    }

    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: celebrateAnimationData3,
        isClickToPauseDisabled: true,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    if (splashState === 1) {
        return (
            <div>
                <Splash />
                {!showModal && <div className="overlay">
                    <div className="loader loader-plus"/>
                </div>}
                <Modal isOpen={showModal} onClose={() => {}} containerClass="retryInApp-container">
                    <RetryModal onRetry={goToHome} />
                </Modal>
            </div>
        )
    } else if (splashState === 2) {
        return (
            <div>
                <UnderMaintenance />
            </div>
        )
    } else {
        return (
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/signals" element={<Signals />} />
                    <Route path="/tasks" element={<DailyTasks />} />
                    <Route path="/affiliate" element={<Affiliate />}/>
                    <Route path="/affiliate/panel" element={<AffiliatePanel />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/*" element={<Error />} />
                </Routes>
                <BottomNavigationMenu />
                {showCelebrate && <div className="fixed">
                    <Lottie
                        isClickToPauseDisabled={true}
                        options={defaultOptions}
                        height="100%"
                        width="100%"
                        eventListeners={[
                            {
                                eventName: 'complete',
                                callback: () => dispatch(AppStore.actions.setShowCelebrate(false)),
                            },
                        ]}/>
                </div>}
            </Layout>

        );
    }
}

export default Main;
